import * as Sentry from "@sentry/react"

import type { ServerConfig } from "./config"

export const initSentry = (config: ServerConfig): void => {
  const { sentry_dsn, release } = config

  if (sentry_dsn !== null) {
    Sentry.init({
      dsn: sentry_dsn,
      release: release ?? undefined,
    })
  }
}
